import { observable, computed, action } from "mobx";
import { InstrumentationEventDomEventFired, isDomEventFiredEvent } from "../Events/InstrumentationEvent";
import { mapGetOrCreate } from "../utils/mapGetOrCreate";
import { DbRecordedEvent, ISODateTimeString, UUID } from "../../State/EvidenceDB/DatabaseTypes";
import { NonSearchChronologicalEvent } from "../../workers/NetworkEventDbSearchWebWorkerStructures";

export class NonSearchChronologicalEventsObserver {
	private _reportableEvents = observable.array<NonSearchChronologicalEvent>();
	private _domEventFiredEvents = observable.array<DbRecordedEvent<InstrumentationEventDomEventFired>>();
	private _domFiredEventsForElementUuid = observable.map<UUID, DbRecordedEvent<InstrumentationEventDomEventFired>[]>();

	redundantInputChangeEventFilter = (event: DbRecordedEvent) => {
		if (isDomEventFiredEvent(event)) {
			const {whenRecordedIso, raw, eventIndex} = event;
			const {value=""} = raw;
			const endOfFutureEventWindowIso = ISODateTimeString(new Date(new Date(whenRecordedIso).getTime() + 3000));
			if (event.raw.domOrCustomEventName === "input" || event.raw.domOrCustomEventName === "change") {
				// remove input/change events that are prefixes of future events within the next 3 seconds
				if ((this._domFiredEventsForElementUuid.get(event.raw.elementUUID) ?? []).find( e =>
					e.eventIndex > eventIndex &&
					e.whenRecordedIso < endOfFutureEventWindowIso &&
					(e.raw.value ?? "").startsWith(value)
				)) {
					return false;
				}
			}
		}
		return true;
	};

	@computed get reportableEvents() {
		const {redundantInputChangeEventFilter} = this;
		return this._reportableEvents.filter( redundantInputChangeEventFilter );
	}

	// @computed get domEventFiredEvents() {
	// 	const {redundantInputChangeEventFilter} = this;
	// 	return this._domEventFiredEvents.filter( redundantInputChangeEventFilter );
	// }

	add = action((events: NonSearchChronologicalEvent[]) => {
		this._reportableEvents.push(...events);
		for (const event of events.filter(isDomEventFiredEvent)) {
			this._domEventFiredEvents.push(event);
			if (event.raw.domOrCustomEventName === "input" || event.raw.domOrCustomEventName === "change") {
				// Track input/change events so that we can only show the final input/change
				mapGetOrCreate(this._domFiredEventsForElementUuid, event.raw.elementUUID, () => observable.array()).push(event);
			}
		}
	});


}
